import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators , ReactiveFormsModule, FormsModule, AbstractControl } from '@angular/forms';
import { InventoryService } from 'src/app/service/inventory.service';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CrmService } from 'src/app/service/crm.service';
import { NgClass } from '@angular/common';
import { alertModalWithoutConfirm } from 'src/app/component/helpers/alert';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-forward-service-req',
    imports: [MatFormFieldModule, MatInputModule, MatSelectModule, ReactiveFormsModule, FormsModule, NgClass],
    templateUrl: './forward-service-req.component.html',
    styleUrl: '../../styles/inventory.css'
})
export class ForwardServiceReqComponent {
  @Input({required: true}) selectedServiceInventory: any;
  @Output() requestForwarded = new EventEmitter<string>();
  forwardRequestForm: FormGroup;


 constructor(private fb: FormBuilder,private inventoryService: InventoryService, private crmService: CrmService){
  this.forwardRequestForm = this.fb.group({
    maximumCost: ['', [Validators.required,this.noWhitespaceValidator]],
    comment: ['', [Validators.required,this.noWhitespaceValidator]],
    selectedAdmin: ['', Validators.required]
  })
}

noWhitespaceValidator(control: AbstractControl): { [key: string]: any } | null {
  const isWhitespace = (control.value || '').trim().length === 0;
  return !isWhitespace ? null : { whitespace: true };
}

  ngOnInit() {
   this.getAdminUsersList();
  }




ngOnChanges(changes: SimpleChanges): void {
  if (changes['selectedServiceInventory'] && changes['selectedServiceInventory'].currentValue) {
    this.resetForwardModal(); 
  }
}

  resetForwardModal(): void {
  this.showForwardSuccess = false;
  this.submitted = false;
  this.errorMessage = '';
  this.forwardRequestForm.reset();

  this.forwardRequestForm.get('maximumCost')?.setValidators([Validators.required, this.noWhitespaceValidator]);
  this.forwardRequestForm.get('comment')?.setValidators([Validators.required, this.noWhitespaceValidator]);
  this.forwardRequestForm.get('selectedAdmin')?.setValidators([Validators.required]);

  this.forwardRequestForm.updateValueAndValidity();
}

 
  resetForwardForm(){
    this.showForwardSuccess = false
    // window.location.reload();
    this.getServiceRequestData();
  }

  adminUsers: { value: string, viewValue: string, id: string }[] = [];
  getAdminUsersList() {
    const department = "ADMIN";
    const loggedInUsername = localStorage.getItem("username");
    const loggedInUserId = localStorage.getItem("guestID");
    this.crmService.getAnyUsers(department).subscribe(
      (res) => {
        let data = res["data"];
        this.adminUsers = data.map((adminUser) => {
          return {
            value: adminUser.userName,
            viewValue: adminUser.userName,
            id: adminUser._id
          };
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  blockNonNumeric(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (
      !/[0-9]/.test(event.key) &&
      !allowedKeys.includes(event.key)
    ) {
      event.preventDefault();
    }
  }

    // Price Formatting
    formatCurrency(value: string | number): string {
      if (!value) return "";
      return new Intl.NumberFormat("en-IN").format(Number(value));
    }
    onProductCostInput(event: Event): void {
      const input = event.target as HTMLInputElement;
      const value = input.value.replace(/,/g, "");
      this.forwardRequestForm.get("maximumCost")?.setValue(value, { emitEvent: false });
      input.value = this.formatCurrency(value);
    }

  showForwardSuccess = false;
   errorMessage = ''
   submitted = false;
  onSubmitForwardReq(serviceReq: any) {
    console.log({ serviceReq })
    console.log('REQUEST ID', serviceReq.requestId)
    console.log(this.forwardRequestForm.value)
    const forwardReqValues = {
      ...this.forwardRequestForm.value
    };


    const getForwardRequestFormValue: any = {
      maximumCost: String(forwardReqValues.maximumCost),
      comment: String(forwardReqValues.comment),
      requestId: serviceReq.requestId,
      adminId: forwardReqValues.selectedAdmin,
      redirectUrl: `${environment.redirectUrl}#/inventory/admin-request?filter=Service Request`,
    };
    console.log(serviceReq?.requestId, 'REQUEST ID');
    console.log(serviceReq?.requestId, 'REQUEST ID')

    this.inventoryService.addForwardServiceReq(getForwardRequestFormValue).subscribe(response => {
      console.log('submitted ', response);
      this.requestForwarded.emit(serviceReq.requestId);
      this.showForwardSuccess = true;
      // window.location.reload();
      // this.getServiceRequestData();
      this.forwardRequestForm.reset();
       setTimeout(() => {
      const modalElement = document.getElementById('forwardServiceRequestModal');
      if (modalElement) {
        (window as any).$(`#forwardServiceRequestModal`).modal('hide');
      }
      this.showForwardSuccess = false; 
    }, 2000);
    },
    
      error => {
       if (this.forwardRequestForm.invalid) {
          console.log("invalid");
          return alertModalWithoutConfirm(
            "warning",
            "Please fill in all required fields before submitting.",
          );
        }
        
       if (error?.error?.message?.message === "Request Already Active!") {
      this.errorMessage = "This request is already active.";
    } else {
      this.errorMessage = "Something went wrong. Please try again.";
    }
        console.error('Error', error);
      });
  }


  selectedSerInventory: any = {};
  serviceRequest = [];
  totalService: any;
  getServiceRequestData() {
    const field: any = {
      pageNum: 1,
      limit: 20,
    };
  
    this.inventoryService.getServiceRequest(field).subscribe((res) => {
      this.serviceRequest = res["data"].records;
  
     
      const assetIds = this.serviceRequest
        .map((item: any) => item.assetId)
        .filter((assetId: any) => assetId !== null); 
  
      console.log("Service Request Asset IDs:", assetIds);
  
      this.totalService = res["data"].totalCounts;
      console.log("Service Response", res);
     
    });
  }
}
